module.exports = __webpack_public_path__ + "static/landt-03bfa97fe7bcce0621c27fdc90e6919e.png";